import { render } from "./Statut.vue?vue&type=template&id=6323dfcd&scoped=true&ts=true"
import script from "./Statut.vue?vue&type=script&lang=ts"
export * from "./Statut.vue?vue&type=script&lang=ts"

import "./Statut.vue?vue&type=style&index=0&id=6323dfcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6323dfcd"]])

export default __exports__